export class ListDashboardsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "dashboards",
            "baseName": "dashboards",
            "type": "Array<Dashboard>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDashboardsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
